import styled from "@emotion/styled";

import { IconButton } from "../../buttons";

export const SidebarIcon = styled(IconButton)`
  border-radius: ${({ theme }) => theme.borderRadius}px;
  border: none;
  margin: 5px auto;

  width: 40px;
  height: 40px;

  font-size: 24px;

  text-align: center;
  transition: all 0.2s ease-in-out;

  div {
    margin-top: 8px;
  }

  svg {
    fill: transparent;
    color: ${({ theme }) => theme.generalTextIcon};

    path {
      stroke: ${({ theme }) => theme.generalTextIcon};
      fill: ${({ theme }) => theme.surface};
    }
  }

  &.isActive,
  &:hover {
    background-color: ${({ theme }) => theme.primaryContainer};

    svg {
      color: ${({ theme }) => theme.primaryStrong};
      path {
        stroke: ${({ theme }) => theme.primaryStrong};
      }
    }
  }

  &.isActive:before {
    content: "";
    position: absolute;
    left: 0;
    top: 6px;
    bottom: 6px;
    width: 4px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.primaryStrong};
  }
`;
